import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollRestoration = () => {
  const location = useLocation();
  const scrollYRef = useRef(0);

  useEffect(() => {
    const updateScroll = () => { scrollYRef.current = window.scrollY; };
    window.addEventListener('scroll', updateScroll, { passive: true });
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  useEffect(() => {
    const key = `scroll-${location.pathname}`;

    // Restore position — wait for content to paint
    const saved = sessionStorage.getItem(key);
    if (saved) {
      setTimeout(() => window.scrollTo({ top: +saved, behavior: 'instant' }), 50);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    return () => {
      sessionStorage.setItem(key, String(scrollYRef.current));
    };
  }, [location.pathname]);
};

export default useScrollRestoration;